import { ADMIN_WEB_URL } from '../../../pure-js/libs/Consts'

/** admin-web Vite default port (user-web is 5173). */
const DEFAULT_DEV_ADMIN_WEB_BASE_URL = 'http://localhost:5174'

const getDevAdminWebBaseUrlFromEnv = (): string | null => {
  const envUrl = (import.meta as ImportMeta & { env?: { VITE_ADMIN_WEB_DEV_URL?: string } }).env?.VITE_ADMIN_WEB_DEV_URL
  const url = envUrl?.trim()
  if (!url) return null
  return url
}

const normalizeBaseUrl = (baseUrl: string): string => baseUrl.replace(/\/+$/, '')

const normalizePath = (path: string): string => (path.startsWith('/') ? path : `/${path}`)

export const getAdminWebBaseUrl = (): string => {
  const isLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')

  if (isLocalhost) {
    const envUrl = getDevAdminWebBaseUrlFromEnv()
    return normalizeBaseUrl(envUrl || DEFAULT_DEV_ADMIN_WEB_BASE_URL)
  }

  return normalizeBaseUrl(ADMIN_WEB_URL)
}

export const buildAdminWebUrl = (path: string): string => {
  const baseUrl = getAdminWebBaseUrl()
  return `${baseUrl}${normalizePath(path)}`
}
